export const SECTION_HANDLES = Object.freeze({
    HOME: 'home',
    ABOUT: 'about',
    BLOG: 'blog',
    ARTICLES: 'articles',
    BUSINESS_AREAS: 'businessAreas',
    SOLUTIONS: 'solutions',
    EXPERTISE: 'expertise'
})
